import React from "react";
import { Box, useTheme } from "@mui/material";
import CustomTypography from "../../../../../views/components/common/form/CustomTypography";
import { POD_PROJECT_OPS_DISABLED_MESSAGE } from "../../../../../models/Project/OrderType";

const PodProjectOpsDisabledBanner: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: 1,
        mt: 2,
        mb: 1,
        px: 2,
        py: 1.5,
        borderRadius: 1.5,
        border: `1px solid ${theme.palette.customColors?.softBorder || theme.palette.divider}`,
        backgroundColor:
          theme.palette.customColors?.blueLightBackground ||
          theme.palette.action.hover,
      }}
    >
      <CustomTypography
        variant="body2"
        fontWeight={700}
        color={
          theme.palette.customColors?.darkBlueText ||
          theme.palette.text.primary
        }
        sx={{ fontSize: "0.85rem", lineHeight: 1.5 }}
      >
        {POD_PROJECT_OPS_DISABLED_MESSAGE}
      </CustomTypography>
    </Box>
  );
};

export default PodProjectOpsDisabledBanner;
